import { render, staticRenderFns } from "./CustomPopup.vue?vue&type=template&id=579b8aa2&"
import script from "./CustomPopup.vue?vue&type=script&lang=js&"
export * from "./CustomPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports